import { t } from '@repo/i18n';
import { useLocale } from '@repo/i18n/react';
import { Link, type LoaderFunctionArgs, redirect, useLoaderData } from 'react-router';
import { ResetPasswordForm } from '@/components/forms/reset-password';
import { trpc as trpcClient } from '@/providers/trpc-client';

const loader = async ({ params }: LoaderFunctionArgs) => {
  const { token } = params;
  if (!token) {
    throw redirect('/auth/reset-password');
  }
  const isValid = await trpcClient.auth.getResetTokenValidity.query({ token });
  if (!isValid) {
    throw redirect('/auth/reset-password');
  }

  return {
    token,
  };
};

export { loader as resetPasswordTokenLoader };

export const ResetPasswordTokenPage = () => {
  useLocale();

  const { token } = useLoaderData<typeof loader>();

  return (
    <div className="w-screen max-w-lg px-4">
      <div className="w-full">
        <h1 className="font-semibold text-4xl">{t('auth.resetPassword')}</h1>

        <p className="mt-2 text-muted-foreground text-sm">
          {t('auth.pleaseChooseYourNewPassword')}
        </p>

        <ResetPasswordForm className="mt-4" token={token} />

        <p className="mt-6 text-center text-muted-foreground text-sm">
          {t('auth.donTHaveAnAccount')}{' '}
          <Link className="text-primary duration-200 hover:opacity-70" to="/auth/signup">
            {t('auth.signUp')}{' '}
          </Link>
        </p>
      </div>
    </div>
  );
};
